@import "../../styles/InputMixins";

:host {
  display: block;
}

.input {
  @include input-control;
  padding-right: 40px;
  background-image: url("data:image/svg+xml;utf8,<svg fill='black' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>");
  background-repeat: no-repeat;
  background-position: right 12px center;

  &[aria-invalid="true"] {
    padding-right: 80px;
  }
}

.inputContainer {
  @include input-container;
}

.errorIcon {
  @include input-error-icon(48px);
}

.inputLabel {
  @include input-label;
}

.errorInfo {
  @include input-error;
}
